<template>
  <div class="mx-auto flex max-w-xl gap-4">
    <p class="text-vgmedturq text-sm font-semibold">Step:</p>
    <v-progress-linear
      :model-value="(100 * currentStep) / totalSteps"
      :color="vgTeal"
      height="20"
      :bg-color="vgSilver"
      class="!left-0 !translate-x-0"
    >
      <strong
        :class="`${
          (100 * currentStep) / totalSteps < 50 ? 'text-black' : 'text-white'
        } `"
        >{{ currentStep }} of {{ totalSteps }}</strong
      >
    </v-progress-linear>
  </div>
</template>
<script>
import tailwind from 'tailwind.config';

export default {
  name: 'ProgressBar',
  props: {
    currentStep: {
      type: Number,
      default: 0,
    },
    totalSteps: {
      type: Number,
      default: 6,
    },
  },
  data() {
    return {
      vgTeal: tailwind.theme.extend.colors.vgteal[700],
      vgSilver: tailwind.theme.extend.colors.vgsilver[300],
    };
  },
  computed: {},
  methods: {},
};
</script>
<style scoped>
* :deep(.v-progress-linear__background) {
  opacity: 1;
}
</style>
